import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';
import { LogService } from '../services/logging.service';
import { Http, Headers, RequestMethod} from '@angular/http';
import {ServiceError} from '../../common/error/service.error'
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/retryWhen';

@Injectable()
export class BaseDao {
  _logService;
  _http;
  constructor (
    logService: LogService,
    http: Http
  ) {
    this._logService = logService;
    this._http = http;
  }

  get(useCache: boolean = true, ...config): Observable<any> {
    const [
      apiKey,
      interval,
      retry,
      timeout,
      url,
      ssoToken,
      apiToken
    ] = config;

    const args = this.buildHeader(apiKey, ssoToken, apiToken);
    return this._http.get(url, args)
      .map( res => res.json())
      .retryWhen( e => this.handleRetry(e, retry, interval, timeout, RequestMethod.Get, url));
  }

  post(data: any, ...config): Observable<any> {
    const [
      apiKey,
      interval,
      retry,
      timeout,
      url,
      ssoToken,
      apiToken
    ] = config;

    const args = this.buildHeader(apiKey, ssoToken, apiToken);
    return this._http.post(url, data, args)
      .map( res => res.json() )
      .retryWhen( e =>  this.handleRetry(e, retry, interval, timeout, RequestMethod.Post, url, data))
  }

  delete(data: any, ...config): Observable<any> {
    const [
      apiKey,
      interval,
      retry,
      timeout,
      url,
      apiToken
    ] = config;

    let args = this.buildHeader(apiKey, '', apiToken);
    args.headers.append('IHG-LANGUAGE', 'en-US');

    return this._http.delete(url, args)
      .map( res => res.json() )
      .retryWhen( e =>  this.handleRetry(e, retry, interval, timeout, RequestMethod.Delete, url));
  }

  private buildHeader(apiKey: string, ssoToken?: string, apiToken?: string) {
    const headers = new Headers();
    headers.append('X-IHG-API-KEY', apiKey);

    if (ssoToken && ssoToken.length > 0) {
      headers.append('X-IHG-SSO-TOKEN', ssoToken);
    }
    if (apiToken && apiToken.length > 0) {
      headers.append('X-IHG-MWS-API-Token', apiToken)
    }

    const args: any = {
      headers: headers
    };
    return args;
  }

  private handleRetry = (
    errors:  Observable<any>,
    retryCount: number = 10,
    delay: number = 5000,
    timeout: number = 10000,
    method: RequestMethod,
    url: string,
    data: object = undefined
  ): Observable<any> => {

    return errors.scan( (count, err) => {
      const serviceError = new ServiceError(err.status, 'Error on base.dao', method, url, data, (err && err._body) ? err._body : undefined);
      ++count;
      // retry a timeout and 500 - if we exceed the retry count (same count for all), throw an error
      switch (err.status) {
        case -1:
        case 500:
          if (count > retryCount) {
            throw serviceError;
          }
          break;
        default:
          // no retrying for 400, 401, 404, or 407
          throw serviceError;
      }
      return count;
    }, 0)
      .takeWhile( count => count <= (retryCount + 1) )
      .delay(delay)
      .timeout(timeout);
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/daos/base.dao.ts